module.exports = __webpack_public_path__ + "static/media/Mariachi_Rubric.feae4164.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Mariachi_Rubric.pdf
// module id = 235
// module chunks = 0